import React from 'react';

import { createRoot } from 'react-dom/client';
import { RematchContext, rematchStore } from 'models/rematchStore';
import moment from 'moment-timezone';
import { env } from './common/config';
import { APP_TIMEZONE } from 'common/constants';
import RouterConfig from './router/RouterConfig';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';

const history = createBrowserHistory();

// Turn this on manually or set a flag if doing performance tests
// otherwise debugging by console is not possible
if (env.NODE_ENV !== 'production') {
    // eslint-disable-next-line global-require
    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React);
}

(function initializeDatesWithCorrectTimezone() {
    moment.tz.setDefault(APP_TIMEZONE);
})();

const container = document.getElementById('app');
const root = createRoot(container);

// Render the app with Provider
root.render(
    <Provider context={RematchContext} store={rematchStore}>
        <RouterConfig history={history} />
    </Provider>
);
